import React, {memo, useCallback, useEffect} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {CustomRadio} from '@buncha/components/core/input/choice';
import {H5Text} from '@buncha/components/core/text';
import {RescheduleOptionNode} from '@buncha/B2B/types/reschedule';
import RescheduleRunSelectNode from '../RescheduleRunSelectNode';
import {StyleSheet} from 'react-native';

interface Props {
  header: string;
  value: number | undefined;
  data: RescheduleOptionNode[];
  handleOnPress: (val: number) => void;
  disabled?: boolean;
}

const RescheduleRunSelect = (props: Props) => {
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const {header, value, data, handleOnPress, disabled} = props;

  const renderCellNode = useCallback(
    (node: RescheduleOptionNode) => {
      return (
        <RescheduleRunSelectNode
          node={node}
          handleOnPress={handleOnPress}
          disabled={disabled}
        />
      );
    },
    [handleOnPress, disabled],
  );

  useEffect(() => {
    if (data?.length === 1) handleOnPress(data?.[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Box
      style={[
        styles.parent,
        {
          borderColor: theme?.background.gray[200],
        },
      ]}>
      <H5Text
        style={[
          styles.header,
          {
            fontFamily: muli[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {header}
      </H5Text>
      <CustomRadio
        selectedValue={value}
        cellNode={renderCellNode}
        data={data}
        setValue={handleOnPress}
        containerStyle={[
          styles.radioContainer,
          {
            borderColor: theme?.text.gray[200],
          },
        ]}
        selectedContainerStyle={{
          backgroundColor: theme?.text.blue[400],
        }}
        radioStyle={{borderColor: theme?.text?.gray?.[100]}}
        selectedCircleStyle={{
          borderColor: theme?.text?.gray?.[100],
        }}
        selectedSmallCircleStyle={{
          backgroundColor: theme?.text?.blue?.[300],
        }}
      />
    </Box>
  );
};

export default memo(RescheduleRunSelect);

const styles = StyleSheet.create({
  parent: {
    marginTop: 8,
    borderWidth: 2,
    borderRadius: 7,
    padding: 12,
    paddingBottom: 4,
  },
  header: {
    textAlign: 'left',
    paddingBottom: 8,
  },
  radioParent: {
    overflow: 'hidden',
  },
  radioContainer: {
    borderWidth: 1,
    borderRadius: 7,
    marginVertical: 8,
    paddingLeft: 12,
  },
  nodeTouchable: {flex: 1, padding: 12},
  nodeText: {textAlign: 'left'},
  nodeTextSubtitle: {textAlign: 'left', marginLeft: 12},
});
